import { Injectable } from '@angular/core';

import { EmailComposer } from '@awesome-cordova-plugins/email-composer/ngx';

import { LoggerService } from '../logger.service';
import { PlatformService } from '../ssr/platform.service';

interface EmailOptions {
  to: string;
  subject: string;
}

const GMAIL_CLIENT = 'gmail';
const OUTLOOK_CLIENT = 'outlook';

@Injectable({ providedIn: 'root' })
export class EmailComposerPlugin {
  constructor(private platformService: PlatformService, private emailComposer: EmailComposer, private loggerService: LoggerService) {}

  public async open(options: EmailOptions): Promise<boolean> {
    if (this.platformService.isAndroid) {
      return this.emailComposer
        .open(options)
        .then(() => true)
        .catch((error: unknown) => {
          this.loggerService.info({
            component: 'EmailComposerPlugin',
            message: "couldn't open default email client",
            details: { error },
            fromPlugin: true,
          });
          return false;
        });
    }

    const hasAccount = (await this.emailComposer.hasAccount()) as boolean;

    if (hasAccount) {
      return this.emailComposer
        .open(options)
        .then(() => true)
        .catch((error: unknown) => {
          this.loggerService.info({
            component: 'EmailComposerPlugin',
            message: "couldn't open default email client",
            details: { error },
            fromPlugin: true,
          });
          return false;
        });
    }

    const hasOutlookClient = (await this.emailComposer.hasClient(OUTLOOK_CLIENT)) as boolean;

    if (hasOutlookClient) {
      return this.emailComposer
        .open({ app: OUTLOOK_CLIENT, ...options })
        .then(() => true)
        .catch((error: unknown) => {
          this.loggerService.info({
            component: 'EmailComposerPlugin',
            message: "couldn't open outlook client",
            details: { error },
            fromPlugin: true,
          });
          return false;
        });
    }

    const hasGmailClient = (await this.emailComposer.hasClient(GMAIL_CLIENT)) as boolean;

    if (hasGmailClient) {
      return this.emailComposer
        .open({ app: GMAIL_CLIENT, ...options })
        .then(() => true)
        .catch((error: unknown) => {
          this.loggerService.info({
            component: 'EmailComposerPlugin',
            message: "couldn't open gmail client",
            details: { error },
            fromPlugin: true,
          });
          return false;
        });
    }

    this.loggerService.info({ component: 'EmailComposerPlugin', message: "couldn't open any email details:clients", fromPlugin: true });
    return false;
  }
}
